// @flow
import PlainTooltip, { type PlainTooltipProps } from './plain-tooltip';

export default PlainTooltip;
export type { PlainTooltipProps };
